module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "status-badge"
  }, [(_vm.status == 0) ? _c('span', {
    staticClass: "draft"
  }, [_vm._v("Draft")]) : _vm._e(), _vm._v(" "), (_vm.status == 1) ? _c('span', {
    staticClass: "published"
  }, [_vm._v("Published")]) : _vm._e(), _vm._v(" "), (_vm.status == 2) ? _c('span', {
    staticClass: "archived"
  }, [_vm._v("Archived")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54436761","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/common/status.vue
// module id = 998
// module chunks = 0